import _ from 'lodash'

export const createSuccessMessageSelector = (actions) => (state) => {
    const last = _.get(state, `successReducer.__LAST`)
    const messages = _.compact(
        _.map(actions, (action) => _.get(state, `successReducer.${action}`))
    )
    const message = _.find(messages, (m) => m === last) || ''
    return message
}

export const createSuccessToastSelector = () => (state) => {
    return state.successReducer.toastList
}